import React from 'react';

import { updateToIdsAction, updateToIdsOnServerAction } from 'actions/task';
import styled from 'styled-components';

import ToIdsV2 from '../ToIdsV2';

export default function TaskToIds({
  dispatch,
  taskId,
  taskKey,
  employees,
  isEditing,
  renderEmptyView,
  maxNodes,
  iconSize,
  disableOnClick = false,
}) {
  function onUpdate(newEmployees) {
    isEditing
      ? dispatch(updateToIdsAction({ id: taskId, key: taskKey, toIds: newEmployees }))
      : dispatch(updateToIdsOnServerAction({ id: taskId, key: taskKey, toIds: newEmployees }));
  }

  return (
    <StyledToIdsComponent
      maxNodes={maxNodes}
      employees={employees}
      onUpdate={disableOnClick ? () => {} : onUpdate}
      popUpDivId={`${taskId || taskKey}-card-ownerEdit`}
      renderEmptyView={renderEmptyView}
      iconSize={iconSize}
      disableOnClick={disableOnClick}
    />
  );
}

const StyledToIdsComponent = styled(ToIdsV2)`
  ${'' /* padding-right: 0.5rem; */}
  display: inline-flex;
`;
